import React, { useState } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import SearchSelect from '../../components/SearchSelect';

const AlertCreateModal = ({ show, handleClose }) => {
    const [reminderValue, setReminderValue] = useState('');

    const handleSelectChange = (e) => {
        setReminderValue(e.target.value);
    };

    // Determine the class based on the reminderValue
    const getClassForValue = () => {
        switch (reminderValue) {
            case '0':
                return 'text-danger border-danger'; // Danger
            case '10':
                return 'text-warning border-warning'; // Warning
            case '20':
                return 'text-success border-success'; // Success
            default:
                return ''; // Default class
        }
    };
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Form>
                    <Modal.Header className="border-0" closeButton>
                        <Modal.Title className="h5">Create Alert</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">

                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Name:</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Name" />
                                </Form.Group>
                            </div>

                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Message:</Form.Label>
                                    <Form.Control as="textarea" placeholder="Enter your message" rows={3} />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Expiry Date:</Form.Label>
                                    <Form.Control type="date" value="2024-10-04" />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Minus Reminder Date:</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={reminderValue}
                                        clas="form-select"
                                        onChange={handleSelectChange}
                                        className={getClassForValue()} // Apply dynamic class
                                    >
                                        <option value="0">0</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Notification Date:</Form.Label>
                                    <Form.Control type="date" value="2024-10-04" />
                                </Form.Group>
                            </div>

                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Send Notification to Driver:</Form.Label>
                                    <div className="d-flex">
                                        <Form.Check type="checkbox" label="SMS" className="me-3" />
                                        <Form.Check type="checkbox" label="Email" />
                                    </div>
                                </Form.Group>
                            </div>

                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Send Notification to System:</Form.Label>
                                    <div className="d-flex">
                                        <Form.Check type="checkbox" label="SMS" className="me-3" />
                                        <Form.Check type="checkbox" label="Email" className="me-3" />
                                        <Form.Check type="checkbox" label="Notification" />
                                    </div>
                                </Form.Group>
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer className="border-0">
                        <Button variant="primary" onClick={handleClose}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Form>

            </Modal>
        </>
    );
};

export default AlertCreateModal;